import { ChangeEvent, useState } from "react"
import { CSS_UNITS, IMagnitude } from "src/libs/interfaces/layouts"
import IScalarForm from "../interface/IScalarForm"
import Scalar from "./Scalar"

/* Protopia Ecosystem component */ 
const CSSMagnitude = (props: IScalarForm): JSX.Element => {
    return <Scalar 
        { ...props }  
        notClear
        enabledForm={<MagnitudeEnabled {...props} />}
        desabledForm={<MagnitudeDisabled {...props} />}
    />
}

const MagnitudeEnabled = (props: IScalarForm): JSX.Element => {
    const parse = (value: string | number | undefined) : IMagnitude => {
        if( typeof value == "undefined") {
            return {} as IMagnitude
        }
        if( typeof value == "number" ) {
            return {
                value,
                units: CSS_UNITS.PX
            } as IMagnitude
        } 
        const vl: number = parseInt( value )
        const units: CSS_UNITS = (( value || "" ).replace(vl.toString(), "") || CSS_UNITS.PX ) as CSS_UNITS
        return { value: vl, units }
    }
    const [ magnitude, setMagnitude ] = useState<IMagnitude | undefined>( 
        typeof  props.value === 'undefined' 
            ? 
                props.default === 'undefined' 
                ?
                undefined
                :
                parse( props.default ) 
            : 
            parse( props.value || props.default ) 
        )
    
    const setMValue = (evt: ChangeEvent<HTMLInputElement>) => {
        const value = Number(evt.currentTarget.value)
        setMagnitude({ value, units: magnitude?.units || CSS_UNITS.PX })
        if(props.onChange) {
            props.onChange( value + "" + (magnitude?.units || CSS_UNITS.PX), props.field, "")
        }
    }
    const setMUnits = (evt: ChangeEvent<HTMLSelectElement>) => {
        const units = evt.currentTarget.value
        setMagnitude({ value : magnitude?.value, units : (units || CSS_UNITS.PX ) as CSS_UNITS })
        if(props.onChange) {
            props.onChange( magnitude?.value + "" + (units || CSS_UNITS.PX ), props.field, "")
        }
    }
    return <div className="d-flex w-100 align-items">
        <input
            type="number"
            value={ magnitude?.value  || undefined }
            className="input form-control dark"
            onChange={setMValue}
        />
        <select
            className="input form-control dark"
            value={magnitude?.units  || undefined }
            onChange={setMUnits}
        >
            {
                Object.values(CSS_UNITS).map( unit => <option key={unit} >{ unit }</option>)
            }
        </select>
    </div>
}

const MagnitudeDisabled = (props: IScalarForm): JSX.Element => {
    return <div className="my-2">{ props.value || props.default }</div>
}
export default CSSMagnitude